var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame277({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 33,
    fill: "#F5EEEE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"bookmark\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.125 24.8933L13.5 20.179L7.875 24.8933V9.80759C7.875 9.30747 8.04432 8.82783 8.34572 8.47419C8.64712 8.12055 9.0559 7.92188 9.48214 7.92188H17.5179C17.9441 7.92188 18.3529 8.12055 18.6543 8.47419C18.9557 8.82783 19.125 9.30747 19.125 9.80759V24.8933Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame277);
export default __webpack_public_path__ + "static/media/Frame 277.ca27907ae23605036beed025dfa0aec1.svg";
export { ForwardRef as ReactComponent };